// src/data/siteData.js
export const siteData = {
  siteName: "University Of Moratuwa Mechanical Engineering Society",
  logo: "/UMMES logo black.png",

  // Navigation structure
  navigation: {
    main: [
      { name: "Home", path: "/" },
      { name: "About", path: "/about-us" },

      // {
      //   name: "Department",
      //   external: true,
      //   url: "https://uom.lk/mech",
      // },
      {
        name: "Events",
        path: "/events",
        dropdown: [
          { name: "Upcoming Events", path: "/events#upcoming" },
          { name: "Past Events (Archive)", path: "/events#past" },
        ],
      },
      // {
      //   name: "Student Life",
      //   path: "/student-life",
      //   // dropdown: [
      //   //   { name: "Clubs and Teams", path: "/student-life#clubs" },
      //   //   { name: "Projects and Achievements", path: "/student-life#projects" },
      //   //   { name: "Gallery", path: "/student-life#gallery" },
      //   // ],
      // },
      { name: "News & Updates", path: "/news" },
      {
        name: "Alumni",
        path: "/alumni",
      },
      { name: "Contact Us", path: "/contact" },
    ],
    utility: [{ name: "Search", path: "/search", type: "search" }],
  },

  // Footer data
  footer: {
    quickLinks: [
      { name: "Home", path: "/" },
      { name: "About", path: "/about-us" },
      { name: "Events", path: "/events" },
      { name: "Contact", path: "/contact" },
    ],
    socials: [
      {
        name: "Facebook",
        url: "https://www.facebook.com/ummes.uom/",
        icon: "facebook",
      },
      // { name: "Twitter", url: "https://twitter.com", icon: "twitter" },
      {
        name: "LinkedIn",
        url: "https://lk.linkedin.com/company/university-of-moratuwa-mechanical-engineering-society",
        icon: "linkedin",
      },
      // { name: "Instagram", url: "https://instagram.com", icon: "instagram" }
    ],
    legal: [
      { name: "Privacy", path: "/privacy" },
      { name: "Terms", path: "/terms" },
      { name: "Contact", path: "/contact" },
      { name: "Location/Map", path: "/location" },
    ],
    newsletter: {
      title: "Stay Updated",
      description: "Subscribe to our newsletter for latest updates",
    },
  },

  // Contact information
  contact: {
    address: "Bandaranayake Mawatha, Moratuwa 10400, Sri Lanka",
    phone1: "+94 11 2 650621",
    phone2: "+94 11 2 650301 ",
    email: "ummers.uom@gmail.com",
    office_hours: "Mon-Fri: 9:00 AM - 5:00 PM",
  },
};

// Hero section data
export const heroData = {
  title: "Welcome to Our University",
  subtitle: "Shaping Tomorrow's Leaders Through Excellence in Education",
  description:
    "Join our vibrant community of students, faculty, and alumni dedicated to academic excellence, innovation, and personal growth.",
  cta: {
    primary: { text: "Explore Programs", link: "/about-us" },
    secondary: { text: "Campus Tour", link: "/contact" },
  },
  backgroundImage: "/hero-bg.jpg",
};
